import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

const alphabet = 'abcdefghijklmnopqrstuvwxyz'.split('');

export const letter = (i: number) => alphabet[i];

export const shuffleArray = <T>(input: T[]): T[] => {
  // make a copy of the array
  const array = input.slice();

  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    // Swap elements directly in the array
    // @ts-expect-error difficult to type
    [array[i], array[j]] = [array[j], array[i]];
  }

  return array;
};

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function memoClassNames<T extends string>(
  comp: string,
  keys: T[],
  opts: { prefix?: string } = {}
) {
  const { prefix = 'Memo' } = opts;

  const classNames = keys.reduce(
    (carry, key) => ({
      ...carry,
      [key]: `${prefix}${comp}-${key}`,
    }),
    {} as { [K in T]: string }
  );

  return classNames;
}
